(function (app) {
    app.provider("purchaseApi", [function () {
        this.$get = [
            "portalApiGateway", function (portalApiGateway) {
                var service = {};
                service.purchase = function(order) {
                    console.log(order);
                    //var testOrder = { PaymentAmount: 1, Frequency: 0, Description: "Lead Club 1 year subscription. One time payment of $3000." };
                    return portalApiGateway.post("/Orders/SubmitOrder/", order);
                };

                service.testComplete = function() {
                    return portalApiGateway.post("/Orders/Test");
                };

                service.getAllOrders = function() {
                    return portalApiGateway.getArray("/Orders/All");
                };

                service.getOrder = function(orderId) {
                    return portalApiGateway.get("/Orders/" + orderId);
                };

                service.getMarketingStrategyOfOrder = function(orderId) {
                    return portalApiGateway.get("/Orders/MarketingStrategy/" + orderId);
                };

                service.getMarketingStrategyByName = function(marketingStrategyName) {
                    return portalApiGateway.get("/Orders/MarketingStrategy/Name/" + marketingStrategyName);
                };

                service.getUserOrders = function(userId) {
                    return portalApiGateway.get("/Orders/User/" + userId);
                };

                service.getMarketingDollars = function () {
                    return portalApiGateway.get("/MarketingDollars");
                };

                service.createMarketingDollars = function (model) {
                    return portalApiGateway.post("/MarketingDollars", model);
                };
                return service;
            }
        ];
    }
    ]);
})(window.app);